import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LOGO_URL } from '../data/mock';
import { Button } from './ui/button';
import { LogOut, User } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

const roleHome = {
  admin: '/admin',
  jakrikra: '/jakrikra',
  nokma: '/nokma',
  applicant: '/applicant',
};

const roleLabel = {
  admin: 'Administrator',
  jakrikra: 'Jakrikra',
  nokma: 'Nokma Sani',
  applicant: 'Applicant',
};

const Navbar = ({ title, subtitle }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 w-full border-b border-border bg-background/85 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to={user ? roleHome[user.role] : '/'} className="flex items-center gap-2 sm:gap-3 min-w-0">
          <img src={LOGO_URL} alt="Nokma Sani Union" className="h-9 w-9 sm:h-11 sm:w-11 rounded-full object-cover ring-2 ring-primary/30 flex-shrink-0" />
          <div className="leading-tight min-w-0">
            <div className="font-serif font-bold text-foreground text-sm sm:text-lg truncate">{title || 'Nokma Sani Union'}</div>
            <div className="hidden sm:block text-xs text-muted-foreground">{subtitle || 'Traditional Administration & Local Self Governance'}</div>
          </div>
        </Link>

        <div className="flex items-center gap-3">
          {!user ? (
            <>
              <Button variant="ghost" onClick={() => navigate('/login')} className="text-foreground hover:text-primary">
                Login
              </Button>
              <Button onClick={() => navigate('/register')} className="bg-primary hover:bg-primary/90 text-primary-foreground">
                Register
              </Button>
            </>
          ) : (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" className="gap-2 border-border">
                  <User className="h-4 w-4" />
                  <span className="hidden sm:inline">{user.name}</span>
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-56">
                <DropdownMenuLabel>
                  <div className="font-medium">{user.name}</div>
                  <div className="text-xs text-muted-foreground">{roleLabel[user.role]}</div>
                </DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => { logout(); navigate('/'); }} className="text-destructive focus:text-destructive">
                  <LogOut className="h-4 w-4 mr-2" /> Sign out
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
